/*globals moment:true*/
'use strict';
angular.module('reporting.dashboards.services')
    .factory('timezoneService', [
    'rsEnvironment',
    function (env) {
        function getFormattedLabel() {
            var matchedZone = getTimezone();
            if (_.contains(moment.tz.names(), matchedZone)) {
                var timezone = moment.tz(matchedZone);
                return matchedZone + ' ' + timezone.format('zz') + ' (GMT' + timezone.format('ZZ') + ')';
            }
            else {
                return 'GMT' + detect();
            }
        }
        function detect() {
            return moment(Date.now()).format('ZZ');
        }
        function getTimezone() {
            var ret = (env.get('user') || {}).timezone || env.get('timezone') || moment.tz.guess();
            // Fix for CPR-5385
            // Timezone 'Canada/East-Saskatchewan' is no longer supported by JobSchedulerService
            if (ret === 'Canada/East-Saskatchewan') {
                ret = 'Canada/Saskatchewan';
            }
            return ret;
        }
        return {
            getTimezone: getTimezone,
            detect: detect,
            getFormattedLabel: getFormattedLabel
        };
    }
]);
